const APICOMMON = {
	PROMOTION: '/gateway/vphoto-album/v1/company/h5/marketing', // put and post
	UPLOAD: '/gateway/album/file/upload', //上传接口 --post
	// CITY: '/vphotosgallery/wechat/album/findInternationalCityList', //获取城市接口
	CITY: '/gateway/vphoto-album/v1/copyright/find/city', //获取城市接口
	HOMEPAGESTATUS: '/gateway/vphoto-album/v1/company/h5/switch', //主页状态
	BASEINFODETIAL: '/gateway/vphoto-album/v1/company/h5/info', //获取基础信息详情
	ALBUMSAHRE: '/gateway/vphoto-album/v1/company/h5/domain', //相册分享
	ACTIVITYALBUMLIST: '/gateway/vphoto-album/v1/company/h5/activity/album/list', //活动列表
	UPDATEACTIVITYALBUM: '/gateway/vphoto-album/v1/company/h5/activity', //修改活动相册
	AUTHADMIN: '/gateway/vphoto-album/v1/company/h5/leader', //是否具有管理员权限
	AMDINLIST: '/gateway/vphoto-album/v1/company/h5/find/company/user', //获取管理员列表
	ADMINADD: '/gateway/vphoto-album/v1/company/h5/save/user', //新增管理员
	ADMINREMOVE: '/gateway/vphoto-album/v1/company/h5/del/company/user' //删除管理员
};
const APICOPYRIGHT = {
	COPYRIGHTTOPICLIST: '/gateway/vphoto-album/v1/copyright/head/topic/list', //首页获取头图列表
	COPYRIGHTSPORTLIST: '/gateway/vphoto-album/v1/copyright/topic/list', //首页获取活动列表
	CAPTCHA: '/gateway/vphoto-album/v1/copyright/send/verifyCode', // 绑定手机时获取验证码
	BIND_PHONE: '/gateway/vphoto-album/v1/copyright/mobile/bind', // 绑定手机号 微信用
	BIND_PHONE_PC: '/gateway/vphoto-album/v1/copyright/login', // 绑定手机号 PC 用
	GET_WXINFO: '/gateway/vphoto-album/v1/copyright/getWxInfo', // 微信扫码登录
	LIST_BY_SECTIONID: '/gateway/vphoto-album/v1/copyright/section/list', // sectionId 获取列表
	COPYRIGHTACTIVITYDETAIL: '/gateway/vphoto-album/v1/copyright/topic', // 获取活动详情
	UPLOADHISTORY: '/gateway/vphoto-album/v1/copyright/content/update/history', // 上传历史列表
	USERINFO: '/gateway/vphoto-album/v1/copyright/find/user', // 获取用户信息
	LOGOUT: '/gateway/vphoto-album/v1/copyright/logout', // 获取用户信息
	UPDATENICKNAME: '/gateway/vphoto-album/v1/copyright/update/nickname', // 获取用户信息
	UNIONUPLOAD: '/union-upload/upload/copyright/uploadFiles', //'/union-upload/upload/uploadFiles', //上传图片
	UPLOADIMGINFO: '/gateway/vphoto-album/v1/copyright/upload/photo', //上传图片信息
	UPLOADTOKEN: '/union-upload/upload/getUploadAccessToken', //断点续传获取上传token
	GETUPLOADREDISKEY:'/union-upload/upload/uploadFilesVo',//获取分片上传的rediskey
	COPYRIGHTGALLERYLIST: '/gateway/vphoto-album/v1/copyright/content/list',// 获取活动图片列表
	COPYRIGHTPRIZELIST: '/gateway/vphoto-album/v1/copyright/content/list/findPrizeList',// 获取活动获奖列表
	GETIMGAGEINFO: '/gateway/vphoto-album/v1/copyright/content/detail', //获取当前图片信息
	DOWNLOADQRCODE: '/gateway/album/v1/mini/app/media/download/qr/code',
	DOWNLOADINFO: '/gateway/vphoto-album/v1/copyright/add/download', // 上传下载信息
	UPLOADAVATAR: '/gateway/vphoto-album/v1/copyright/update/avatar', //上传头像
	SEARCHTOUTU: '/gateway/vphoto-album/v1/copyright/section/search/list', //投图搜索功能
	GALLERYIMGPRAISELIST: '/gateway/vphoto-album/v1/copyright/like/list', //点赞列表
	GALLERYIMGPRAISE: '/gateway/vphoto-album/v1/copyright/like', //点赞
	GALLERYIMGCANCELPRAISE: '/gateway/vphoto-album/v1/copyright/cancel/Like', //取消点赞
	TOPICCONFIGLIST: '/gateway/vphoto-album/v1/copyright/find/findSpecialList', //专题配置列表
	BANNERCONFIGLIST: '/gateway/vphoto-album/v1/copyright/find/findBannerList', //banner配置列表
	ACTIVITYCONFIGLIST: '/gateway/vphoto-album/v1/copyright/find/findBasicsActivityList', //活动配置列表
	PLACARDITEMLIST: '/gateway/vphoto-album/v1/copyright/find/findPlacardItemList', //首页获取精选推荐列表
	WEIXINCONFIG: '/vphotosgallery/wechat/album/js/config', // 获取微信配置信息
	WEIXINTOKEN: '/vphotosgallery/wechat/album/authWechat', // 微信code换token
	NEWSLIST: '/gateway/vphoto-album/v1/copyright/find/findByNewsResps', //获取新闻列表
	NEWSDETAIL: '/gateway/vphoto-album/v1/copyright/find/findByNewsRespDetail', //获取新闻详情
	NEWSHISTORYLIST: '/gateway/vphoto-album/v1/copyright/find/findByNewsResps', //获取新闻历史列表
	UPDATEREADNUM: '/gateway/vphoto-album/v1/copyright/update/updateReadNum', //增加新闻阅读量
	INSERTNEWSPRAISE: '/gateway/vphoto-album/v1/copyright/insert/insertNewsPraise', //新闻点赞
	DELETENEWSPRAISE: '/gateway/vphoto-album/v1/copyright/delete/deleteNewsPraise', //新闻取消点赞
};
const APIUSER = {
	VERIFY: '/account/sync/verify' //TOKEN校验
};
const APIREPORT = {
	DEMOREPORT: '/gateway/vphoto-album/v1/report/pv' //REPORT demo 路径
};
export { APICOMMON, APIUSER, APICOPYRIGHT, APIREPORT };
